// ChildNode.remove
(function () {
  "use strict";

  if(!("remove" in Element.prototype)){
    Element.prototype.remove = function(){
      if(this.parentNode) {
        this.parentNode.removeChild(this);
      }
    };
  }
})();



//////////////////
// WEBPACK FOOTER
// ./node_modules/go-native/src/utilities/childNode.remove.js
// module id = 17
// module chunks = 0